// Endpoints

export const ENDPOINT_DATA_AXURE = 'https://datak.keraunos.co/ApiAxuretechnologies/';
export const ENDPOINT_DATA_GEOSERVICIOS = 'https://datak.keraunos.co/GEOServicios/';

// Constants

export const DEFAULT_CIRCLE_SIZE_PIXELS = 5;
export const GIS_ALERT_ICON_SIZE_PIXELS = 24;
export const GIS_ANNOUNCER_ICON_SIZE_PIXELS = 16;
export const GIS_SCE_ICON_SIZE_PIXELS = 18;
export const GIS_ANNOUNCER_LEGEND_ICON_SIZE_PIXELS = 16;
export const GIS_CLUSTERING_ZOOM_THRESHOLD = 8;
export const GIS_LIGHTNING_ICON_HISTORIC_SIZE_PIXELS = 24;
export const GIS_LIGHTNING_ICON_RADIUS_PIXELS = 2.5;
export const GIS_POINT_ICON_SIZE_PIXELS = 35;
export const GIS_POINT_LEGEND_ICON_SIZE_PIXELS = 24;
export const GIS_SOUND_ALERT_MAXIMUM_DURATION_SECONDS = 20;
export const GLOBAL_ENCRYPTION_KEY = '123456';
export const REALTIME_INTERVAL_SECONDS = 10;
export const REALTIME_INTERVAL_SECONDS_U = 30;

// Enumerations

export const ROUTES_NAMES = {
    '/': 'Tiempo real',
    '/tiempoReal': 'Tiempo real',
    '/historico': 'Historico',
    '/report': 'Reporte',
    '/TWS': 'TWS',
    '/ayuda': 'Ayuda',
    '/rayos': 'Descarga rayos'
};

export const COLORS_PROJECT = {
    color_back: '#eef2f3',
    color_nav: '#334F68',
    color_enc_table: '#fdfefe',
    color_nav_secondary: '#dd1818',
    color_nav_letter: '#fff',
    color_nav_letter_enc_table: '#2c3e50',
    color_nav_letter_secondary: '#000',
    color_letter_dashboard: 'black',
    color_button_gis: 'yellow',
    color_alarm_yellow: '#F9F60F',
    color_alarm_orange: '#FA960F',
    color_alarm_red: '#FA2B0F',
    color_alarm_green: '#48C71E',
    color_alarm_grey: '#70766E',
    color_shape_one: '#1E8449',
    color_shape_two: '#F4D03F',
    color_shape_three: '#ec5353',
    color_shape_zero: '#616a6b',
    color_shape_h: '#616a6b08',
    color_background_tables: '#ffffff',
};

export const PointColors = {
    3: {
        fill: 'red',
        stroke: 'white',
    },
    2: {
        fill: 'orange',
        stroke: 'gray',
    },
    1: {
        fill: 'yellow',
        stroke: 'gray',
    },
    0: {
        fill: 'green',
        stroke: 'white',
    },
};

export const LightningColors = {
    1: '#FF0000',
    5: '#FF6600',
    10: '#FF9933',
    20: '#FFCC00',
    30: '#FFFF00',
    40: '#CCFF33',
    50: '#99FF33',
    60: '#40FF00',
};

export const AnnouncerColors = {
    LEVEL_3: 'red',
    LEVEL_2: 'orange',
    LEVEL_1: 'yellow',
    LEVEL_0: 'green',
    BORDER: 'black',
    DISCONNECTED: 'gray',
};

export const PointDialogStates = {
    CLOSED: 'CLOSED',
    CREATION: 'CREATION',
    EDITION: 'EDITION',
};
